import {
  SET_ORDERS,
  SET_ORDER_COUNT,
  SET_TOTAL_SALES,
  SET_SELECTED_ORDER,
  LOADING_ORDERS,
  SET_ORDER_ERROR,
  SET_ORDER_REPORT_STATUS,
} from './order.type';
import initialState from '../initialState';

const orderState = {
  ...initialState,
  orders: [],
  loans: [],
  payments: [],
  credits: [],
  orderCount: 0,
  totalSales: 0,
  totalCredits: 0,
  loadingOrders: true,
  loadingLoans: true,
  order: null,
  credit: null,
  paymentStatus: null,
  paymentMethod: null,
  orderStatus: null,
  filteredOrders: [],
  orderReportStatus: null,
};

const orderReducer = (state = orderState, action) => {
  switch (action.type) {
    case LOADING_ORDERS:
      return {
        ...state,
        loadingOrders: action.value,
      };

    case SET_SELECTED_ORDER:
      return {
        ...state,
        order: action.order,
      };

    case SET_ORDER_COUNT:
      return {
        ...state,
        orderCount: action.count,
      };

    case SET_ORDER_REPORT_STATUS:
      return {
        ...state,
        orderReportStatus: action.status,
      };

    case SET_TOTAL_SALES:
      return {
        ...state,
        totalSales: action.total,
      };

    case SET_ORDERS:
      return {
        ...state,
        orders: action.orders,
      };

    case SET_ORDER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

export default orderReducer;
